export enum ThemeType {
	DARK = 'dark',
	LIGHT = 'light',
}

export default {
	ThemeType,
};
